import { forwardRef } from "react";
import BrandingSettingsForm from "../forms/branding/BrandingSettingsForm";
import Loading from "../loading/Loading";
import { useSettingsQuery } from "@/api/queries/admin/SettingsQueries";
import { useSettingsMutation } from "@/api/mutations/admin/SettingsMutations";
import { useTranslation } from "react-i18next";

const BrandingSettingsSection = forwardRef(({ hideSubmitButton }: { hideSubmitButton?: boolean }, ref) => {
    const { t } = useTranslation();
    const { data, isLoading } = useSettingsQuery(true);
    const { mutate } = useSettingsMutation();

    const handleSubmit = (_data: any) => {
        // For branding settings, we need to keep ALL values including empty strings
        // Theme variables can legitimately be empty strings
        const cleaned = _data || {};

        mutate({ branding_settings: cleaned });
    };

    if (isLoading)
        return (
            <div>
                <Loading />
            </div>
        );

    return (
        <section className="flex flex-col gap-4">
            <div className="space-y-2">
                <h1 className="text-2xl font-semibold">{t("settings.brandingSettings.title")}</h1>
                <p className="text-gray-500">{t("settings.brandingSettings.description")}</p>
            </div>
            <div className="rounded-lg border bg-card/40 p-6">
                <BrandingSettingsForm
                    data={data?.branding_settings as any}
                    onSubmit={handleSubmit}
                    hideSubmitButton={hideSubmitButton}
                    ref={ref as any}
                />
            </div>
        </section>
    );
});

BrandingSettingsSection.displayName = "BrandingSettingsSection";

export default BrandingSettingsSection;
